import React from 'react';

/**
 * HOC for converting incoming data to new format
 * */
export var withDataConverter = function withDataConverter(dataConverter) {
  return function (WrappedComponent) {
    return function (props) {
      return /*#__PURE__*/React.createElement(WrappedComponent
      // eslint-disable-next-line react/jsx-props-no-spreading
      , dataConverter(props));
    };
  };
};